import { Button, ButtonVariant } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../../translations';
import { ConsentsAndAuthorizationsDocumentScannerModalOpener } from '../../ConsentsAndAuthorizationsDocumentScannerModal/ConsentsAndAuthorizationsDocumentScannerModal.opener';

type ScanDocumentCellProps = {
   readonly consentDocumentName: string;
   readonly consentDocumentId: number;
   readonly onConfirm: VoidFunction;
};

export const ScanDocumentCell = (props: ScanDocumentCellProps): JSX.Element => {
   return (
      <ConsentsAndAuthorizationsDocumentScannerModalOpener
         consentDocumentName={props.consentDocumentName}
         consentDocumentId={props.consentDocumentId}
         onConfirm={props.onConfirm}
      >
         {({ openModal }) => (
            <Button
               testId={'scanDocument'}
               label={
                  patientConsentsAndAuthorizationsTranslationKeys.consentsAndAuthorizations.table.columns.actions
                     .addDocumentScan
               }
               onClick={openModal}
               type={'button'}
               variant={ButtonVariant.SECONDARY}
            />
         )}
      </ConsentsAndAuthorizationsDocumentScannerModalOpener>
   );
};
